var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32 31.9998C1.5466 27.6317 6.10352e-07 21.9299 0 15.9999C0 10.0699 1.5466 4.3681 4.32 0V31.9998Z",
    fill: "#FF8853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C27.7565 32 23.6869 30.3143 20.6863 27.3137C17.6857 24.3131 16 20.2435 16 16C16 11.7565 17.6857 7.68688 20.6863 4.6863C23.6869 1.68571 27.7565 1.52562e-06 32 6.99383e-07L32 32Z",
    fill: "#FF8853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64629 28.0776C11.2816 29.8233 13.2345 31.1521 15.36 32V0C13.2345 0.847809 11.2816 2.17663 9.64629 3.92238C6.64571 7.12556 4.96 11.47 4.96 16C4.96 20.53 6.64571 24.8744 9.64629 28.0776Z",
    fill: "#FF8853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommVector);
export default __webpack_public_path__ + "static/media/CommVector.d7885dc40317e274ea8b70bb758c2a37.svg";
export { ForwardRef as ReactComponent };